import React, { useEffect, useState } from "react";
import Navbar from "../../common/Navbar";
import Footer from "../../common/Footer";
import * as Constants from "../../../Constants/index";
import axios from "axios";
import swal from "sweetalert";
import DatePicker from "react-datepicker";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { saveAs } from "file-saver";
import { useFormik } from "formik";
import ResponsivePagination from "react-responsive-pagination";
import Oval from "../loader/CircleLoade";
import { Link } from "react-router-dom";

export default function AnomalyReport() {
    const navigate = useNavigate();
    const userType = localStorage.getItem("user_type");
    const token = localStorage.getItem("token");
    const [loading, setLoading] = useState(false);
    const [reportData, setReportData] = useState(null);
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [limit] = useState(10);
    const [filterData, setFilterData] = useState({});
    const [downloadLoading, setDownloadLoading] = useState(false);

    useEffect(() => {
        getReportData(
            {
                mobile: "",
                status: "",
                startDate: "",
                endDate: "",
            },
            1
        );
    }, []);

    const searchFormik = useFormik({
        initialValues: {
            mobile: "",
            status: "",
            startDate: "",
            endDate: "",
        },
        validate: (data) => {
            let errors = {};

            // Make startDate and endDate mandatory
            // if (!data.startDate) {
            //   errors.startDate = "Start date is required";
            // }

            // if (!data.endDate) {
            //   errors.endDate = "End date is required";
            // }

            if (data.startDate && !data.endDate) {
                errors.endDate = "End date is required when start date is selected";
            }

            if (data.mobile) {
                if (data.mobile.length < 10) {
                    errors.mobile = "Mobile must be in 10 digits.";
                }
            }

            if (data.startDate && data.endDate && data.startDate > data.endDate) {
                errors.endDate = "End date should be greater than start date";
            }

            // ✅ Date Range max 30 days
            // if (data.startDate && data.endDate) {
            //   const diffDays = moment(data.endDate).diff(moment(data.startDate), "days");
            //   if (diffDays > 30) {
            //     errors.endDate = "Date range cannot be more than 30 days";
            //   }
            // }

            return errors;
        },
        onSubmit: (data) => {
            setCurrentPage(1);
            getReportData(data, 1);
            setFilterData(data);
        },
    });
    const isSearchFormFieldValid = (name) =>
        !!(searchFormik.touched[name] && searchFormik.errors[name]);
    const getSearchFormErrorMessage = (name) => {
        return (
            isSearchFormFieldValid(name) && (
                <small className="report-error-field">
                    {searchFormik.errors[name]}
                </small>
            )
        );
    };

    const getReportData = async (data, pageNum) => {
        setLoading(true);
        if (!token) {
            navigate("/");
        } else {
            const searchMobile =
                data?.mobile !== undefined && data?.mobile !== ""
                    ? `&mobile=${data?.mobile}`
                    : "";

            const searchStatus =
                data?.status !== undefined && data?.status !== ""
                    ? `&status=${data?.status}`
                    : "";

            let stDate = "";
            let endDate = "";

            // ✅ Only add if both dates are provided
            if (data?.startDate && data?.endDate) {
                const momentObj1 = moment(data.startDate);
                const momentObj2 = moment(data.endDate);

                const startFormattedDate = momentObj1.format("YYYY-MM-DD HH:mm:ss");
                const endFormattedDate = momentObj2.format("YYYY-MM-DD 23:59:59");

                stDate = `&start=${startFormattedDate}`;
                endDate = `&end=${endFormattedDate}`;
            }

            await axios
                .get(
                    Constants.baseUrl +
                    `reports/anomaly/list?${searchMobile}${searchStatus}${stDate}${endDate}&sortBy=createDateTime&sortAsc=true&limit=${limit}&page=${pageNum}`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Accept-Language": localStorage.getItem("langauge"),
                            appVersion: Constants.av,
                            platform: Constants.pt,
                            company: Constants.company,
                            program: Constants.program,
                        },
                    }
                )
                .then((res) => {
                    const dt = res.data;
                    if (dt.result === "success") {
                        setReportData(dt?.output?.results);
                        setTotalPages(dt?.output?.totalPages);
                        setLoading(false);
                    }
                    if (dt.result === "error" || dt.result === "dialog") {
                        setReportData(null);
                        setTotalPages(0);
                        setLoading(false);
                    }
                })
                .catch(() => {
                    setLoading(false);
                });
        }
    };


    const download = (data) => {
        setLoading(true);
        setDownloadLoading(true);
        try {
            const searchMobile = data.mobile === "" ? "" : `&mobile=${data.mobile}`;
            const searchStatus = data.status === "" ? "" : `&status=${data.status}`;
            let stDate;
            let endDate;

            var momentObj1 = moment(data.startDate);
            var momentObj2 = moment(data.endDate);
            if (data.startDate && data.endDate) {
                var startFormattedDate = momentObj1.format("YYYY-MM-DD HH:mm:ss");
                var startFormattedDate4 = momentObj2.format("YYYY-MM-DD 23:59:59");
                stDate = `&start=${startFormattedDate}`;
                endDate = `&end=${startFormattedDate4}`;
            } else {
                stDate = "";
                endDate = "";
            }

            axios
                .get(
                    Constants.baseUrl +
                    `reports/download/anomalyReport?${searchMobile}${searchStatus}${stDate}${endDate}`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Accept-Language": localStorage.getItem("langauge"),
                            appVersion: Constants.av,
                            platform: Constants.pt,
                            company: Constants.company,
                            program: Constants.program,
                        },
                        responseType: "blob", // Set the responseType to 'blob'
                    }
                )
                .then((res) => {
                    if (res.status === 200) {
                        setLoading(false);
                        const fileData = new Blob([res.data], { type: "text/csv" });
                        saveAs(fileData, "anomaly_report.csv");
                        setDownloadLoading(false);
                    } else {
                        swal({
                            text: res.data.msg,
                            // icon: 'error',
                            timer: 2000,
                            buttons: false,
                        });
                        setDownloadLoading(false);
                    }
                });
        } catch (error) {
            console.log(error);
            setDownloadLoading(false);
        }
    };

    const areAllValuesBlank = () => {
        const { mobile, status, startDate, endDate } = searchFormik.values;
        return !mobile && !status && !startDate && !endDate;
    };
    return (
        <>
            {loading ? <Oval /> : null}
            <Navbar />
            <section class="page-content--bge55">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-md-12">
                            <h3 class="head1">Anomaly Report</h3>
                        </div>
                    </div>

                    <div class="card">
                        <div class="card-body">
                            <form onSubmit={searchFormik.handleSubmit}>
                                <div class="row">
                                    <div class="col-lg-8 col-md-12 col-sm-12 col-xs-12">
                                        <div class="row">
                                            <div class="col-md-3 col-sm-12 col-xs-12">
                                                <div class="form-group">
                                                    <input
                                                        class="form-control reset"
                                                        type="text"
                                                        placeholder="Mobile No."
                                                        id="mobile"
                                                        value={searchFormik.values.mobile}
                                                        onChange={(e) => {
                                                            const numericValue = e.target.value
                                                                .replace(/\D/g, "")
                                                                .slice(0, 10);
                                                            searchFormik.handleChange({
                                                                target: {
                                                                    name: "mobile",
                                                                    value: numericValue,
                                                                },
                                                            });
                                                        }}
                                                    />
                                                    {getSearchFormErrorMessage("mobile")}
                                                </div>
                                            </div>
                                            <div className="col-md-3 col-sm-12 col-xs-12">
                                                <DatePicker
                                                    id="startDate"
                                                    selected={searchFormik.values.startDate}
                                                    onChange={(date) =>
                                                        searchFormik.setFieldValue("startDate", date)
                                                    }
                                                    dateFormat="dd-MM-yyyy"
                                                    className="form-control"
                                                    showYearDropdown
                                                    showMonthDropdown
                                                    autoComplete="off"
                                                    scrollableYearDropdown
                                                    maxDate={new Date()}
                                                    onKeyDown={(e) => e.preventDefault()}
                                                    onFocus={(e) => e.target.blur()}
                                                    onClick={(e) => e.preventDefault()}
                                                    placeholderText="From date *"
                                                // required
                                                />
                                                {getSearchFormErrorMessage("startDate")}
                                            </div>
                                            <div className="col-md-3 col-sm-12 col-xs-12">
                                                <DatePicker
                                                    id="endDate"
                                                    selected={searchFormik.values.endDate}
                                                    onChange={(date) => searchFormik.setFieldValue("endDate", date)}
                                                    dateFormat="dd-MM-yyyy"
                                                    className="form-control"
                                                    showYearDropdown
                                                    showMonthDropdown
                                                    autoComplete="off"
                                                    scrollableYearDropdown
                                                    minDate={searchFormik.values.startDate || null} // end date start से छोटी न हो
                                                    maxDate={
                                                        searchFormik.values.startDate
                                                            ? moment(searchFormik.values.startDate).add(30, "days").toDate()
                                                            : new Date()
                                                    }
                                                    onKeyDown={(e) => e.preventDefault()}
                                                    onFocus={(e) => e.target.blur()}
                                                    onClick={(e) => e.preventDefault()}
                                                    placeholderText="To date *"
                                                // required
                                                />
                                                {/* <DatePicker
                          id="endDate"
                          selected={searchFormik.values.endDate}
                          onChange={(date) =>
                            searchFormik.setFieldValue("endDate", date)
                          }
                          dateFormat="dd-MM-yyyy"
                          className="form-control"
                          showYearDropdown
                          showMonthDropdown
                          autoComplete="off"
                          scrollableYearDropdown
                          maxDate={new Date()}
                          onKeyDown={(e) => e.preventDefault()}
                          onFocus={(e) => e.target.blur()}
                          onClick={(e) => e.preventDefault()}
                          placeholderText="To date *"
                          required
                        /> */}
                                                {getSearchFormErrorMessage("endDate")}
                                            </div>
                                            <div className="col-md-3 col-sm-12 col-xs-12">
                                                <select
                                                    className="form-control"
                                                    id="status"
                                                    value={searchFormik.values.status}
                                                    onChange={searchFormik.handleChange}
                                                >
                                                    <option value="">Select Status</option>
                                                    <option value="PENDING">Pending</option>
                                                    <option value="APPROVED">Approved</option>
                                                    <option value="BLOCKED">Blocked</option>
                                                </select>
                                                {getSearchFormErrorMessage("status")}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-12 col-sm-12 col-xs-12">
                                        <div class="d-flex justify-content-between">
                                            <button
                                                type="submit"
                                                class="btn btn-primary report-submit-button"
                                            //disabled={areAllValuesBlank()}
                                            >
                                                Search
                                            </button>

                                            <button
                                                type="button"
                                                className="btn btn-primary report-submit-button"
                                                onClick={() => {
                                                    setFilterData({});
                                                    setCurrentPage(1);
                                                    searchFormik.resetForm();
                                                    getReportData(
                                                        {
                                                            mobile: "",
                                                            status: "",
                                                            startDate: "",
                                                            endDate: "",
                                                        },
                                                        1
                                                    );
                                                }}
                                            >
                                                Reset
                                            </button>

                                            {reportData === null ? (
                                                ""
                                            ) : (
                                                <Link
                                                    to="#"
                                                    class={`btn btn-primary report-submit-button mx-5 ${downloadLoading ? "btn-opacity" : ""
                                                        }`}
                                                    onClick={() => download(searchFormik.values)}
                                                >
                                                    {downloadLoading ? (
                                                        <span>
                                                            {" "}
                                                            <i class="fa fa-spinner fa-spin"></i>Export
                                                        </span>
                                                    ) : (
                                                        " Export"
                                                    )}
                                                </Link>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </form>
                            <div class="row mt-20">
                                <div class="col-md-12">
                                    <div class="table-responsive table--no-card">
                                        <table class="table table-borderless table-striped table-earning">
                                            <thead>
                                                <tr>
                                                    <th>S.No.</th>
                                                    <th>Anomaly ID</th>
                                                    <th>User ID</th>
                                                    <th>Plumber Name</th>
                                                    <th>Plumber Mobile</th>
                                                    <th>Plumber Zone</th>
                                                    <th>Plumber Branch</th>
                                                    <th>FS Name</th>
                                                    <th>FS Mobile</th>
                                                    <th>FS Code</th>
                                                    <th>Registration Date</th>
                                                    <th>Account Status</th>
                                                    <th>Territory Code</th>
                                                    <th>Territory Name</th>
                                                    <th>Anomaly Type</th>
                                                    <th>Anomaly Sub Type</th>
                                                    <th>Claim Id</th>
                                                    <th>Purchase Value</th>
                                                    <th>QR Transaction Id</th>
                                                    <th>Scan Volume/Scan Count</th>
                                                    <th>Limit Value/Volume/Scan Count</th>
                                                    <th>Detection Time</th>
                                                    <th>Current Status</th>
                                                    <th>Decision</th>
                                                    <th>Ack Remarks</th>
                                                    <th>Action By Name</th>
                                                    <th>Action By Mobile</th>
                                                    <th>Action Time</th>
                                                </tr>
                                            </thead>
                                            {reportData === null ? (
                                                <tbody>
                                                    <tr>
                                                        <td
                                                            colSpan="45"
                                                            style={{ textAlign: "center", fontSize: "16px" }}
                                                        >
                                                            No record found!
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            ) : (
                                                <tbody>
                                                    {reportData &&
                                                        reportData.map((item, index) => {
                                                            const serialNumber =
                                                                (currentPage - 1) * limit + index + 1;
                                                            return (
                                                                <tr key={index}>
                                                                    <td>{serialNumber}</td>
                                                                    <td>{item[0]}</td>
                                                                    <td>{item[1]}</td>
                                                                    <td>{item[2]}</td>
                                                                    <td>{item[3]}</td>
                                                                    <td>{item[4]}</td>
                                                                    <td>{item[5]}</td>
                                                                    <td>{item[6]}</td>
                                                                    <td>{item[7]}</td>
                                                                    <td>{item[8]}</td>
                                                                    <td>{item[9]}</td>
                                                                    <td>{item[10]}</td>
                                                                    <td>{item[11]}</td>
                                                                    <td>{item[12]}</td>
                                                                    <td>{item[13]}</td>
                                                                    <td>{item[14]}</td>
                                                                    <td>{item[15]}</td>
                                                                    <td>{item[16]}</td>
                                                                    <td>{item[17]}</td>
                                                                    <td>{item[18]}</td>
                                                                    <td>{item[19]}</td>
                                                                    <td>{item[20]}</td>
                                                                    <td>{item[21]}</td>
                                                                    <td>{item[22]}</td>
                                                                    <td>{item[23]}</td>
                                                                    <td>{item[24]}</td>
                                                                    <td>{item[25]}</td>
                                                                    <td>{item[26]}</td>
                                                                </tr>
                                                            );
                                                        })}
                                                </tbody>
                                            )}
                                        </table>
                                        {totalPages > 1 && (
                                            <ResponsivePagination
                                                current={currentPage}
                                                total={totalPages}
                                                onPageChange={(page) => {
                                                    setCurrentPage(page);
                                                    getReportData(filterData, page);
                                                }}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
}
